import { gql } from '@apollo/client';

export const GET_CONNECTION_DETAILS = gql`
  query GetConnection($id: ID!) {
    getConnection(id: $id) {
      id
      name
      company {
        logo
        name
      }
    }
  }
`;
